import { render, staticRenderFns } from "./total-sessions.card.vue?vue&type=template&id=5f3f35f8&"
import script from "./total-sessions.card.vue?vue&type=script&lang=js&"
export * from "./total-sessions.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports